/*
 * AppShellContext that keeps an indicator whether the page is rendered within
 * AppShell. Wrapping a component with `withRouter` crashes if the Router is not
 * present in the DOM.
 *
 * We use this indicator to detect whether we have Router as we set the
 * indicator to true when we construct this context for AppShell.
 *
 * We also use this to keep track of the entrypoint of the page. This is
 * necessary for our 404 pages to know if they are rendered within a
 * certain entrypoint, or if we should reload the page.
 */
import * as React from "react";

import type {Entrypoint, ProductContext} from "./types.ts";

interface AppShellContextType {
    inAppShell: boolean;
    entrypoint: Entrypoint;
    productContext: ProductContext;
}

export const AppShellContext: React.Context<AppShellContextType> =
    React.createContext<AppShellContextType>({
        inAppShell: false,
        entrypoint: "khanacademy",
        productContext: "KHANACADEMY",
    });
AppShellContext.displayName = "AppShellContext";
